export default function validate(scoringSystem, logger) {
  if (!scoringSystem.name) {
    logger.error('Scoring System must have a name')
    return false
  }

  return true
}
